import { plainTextFromHtml } from '@/js/core/utils/formatters';

const SLUG_SOURCE_LENGTH = 51;

export function routeSlugFromIdentifierAndTitle(identifier, title) {
  const source = [identifier, plainTextFromHtml(title)]
    .filter(Boolean)
    .join(' ')
    .slice(0, SLUG_SOURCE_LENGTH);

  return source
    .toLowerCase()
    .replace(/&[a-z0-9#]+;/gi, '')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
}
